import React, { useEffect } from "react";
import "./Results.css";
import ResultsLayers from "./Identify/ResultsLayers";
import ResultsFeatures from "./Identify/ResultsFeatures";
import FeatureDescription from "./Identify/FeatureDescription";
import { useSelector, useDispatch } from "react-redux";
import GeocodeFeatures from "./Geocoding/GeocodeFeatures";
import GeocodeDescription from "./Geocoding/GeocodeDescription";
import { setDataLinkData, setResultsForFeature } from "../../../redux/resultsSlice";
import { setHorizontalView } from "../../../redux/toolSelectSlice";

const Results = () => {
    const selectedFeatures = useSelector((state) => state.resultsData.results);
    const dataLinkData = useSelector((state) => state.resultsData.dataLinkData);
    const resultsForLayer = useSelector((state) => state.resultsData.resultsForLayer);
    const resultsForFeature = useSelector((state) => state.resultsData.resultsForFeature);
    const dataGridOn = useSelector((state) => state.toolSelect.dataGrid);
    const horizontalViewOn = useSelector((state) => state.toolSelect.horizontalView);
    const dispatch = useDispatch();

    useEffect(() => {
        if (resultsForFeature?.length === 0 && dataLinkData.length !== 0) {
            dispatch(setDataLinkData([]));
        }
    }, [resultsForFeature?.Features]);

    useEffect(() => {
        if (horizontalViewOn && resultsForFeature.length === 0) {
            dispatch(setHorizontalView(false));
        }
    }, [resultsForFeature]);

    return (
        <>
            {" "}
            {dataGridOn === false && (
                <>
                    {
                        // If feature has been selected
                        resultsForFeature.length > 0 && !horizontalViewOn ? (
                            resultsForFeature[0].DisplayName === "ArcGIS Geocoder" ? (
                                <GeocodeDescription />
                            ) : (
                                <FeatureDescription />
                            )
                        ) : // If features for a single layer have been selected
                        resultsForLayer.length > 0 ? (
                            resultsForLayer[0].DisplayName === "ArcGIS Geocoder" ? (
                                <GeocodeFeatures />
                            ) : (
                                <ResultsFeatures />
                            )
                        ) : // If features from multiple layers are selected
                        selectedFeatures.length > 1 ? (
                            <ResultsLayers />
                        ) : (
                            <div className="results-title">No Results</div>
                        )
                    }
                </>
            )}
        </>
    );
};

export default Results;
